import React, { Component } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import "./assets/css/reset.css";
import "./assets/css/App.css";
import Email from "./components/Email";
import Phone from "./components/Phone";
import CallCenterPhone from "./components/CallCenterPhone";
import CallCenterEmail from "./components/CallCenterEmail";
import EmailVerify from "./components/EmailVerify";
import OTPVerify from "./components/OTPVerify";
import Logout from "./components/Logout";
import DeleteAccount from "./components/DeleteAccount";
import axios from "axios";
import CustomerDisplay from "./components/CustomerPortal";
import SessionExpired from "./components/SessionExpired";
import CustomerPortal from "./components/CustomerPortal";
import CryptoJS from "crypto-js";
import EmailHR from "./components/EmailHR";
import SpinnerLoad from "./components/SpinnerLoad";
import Header from "./components/Header";
import Footer from "./components/Footer";

require("dotenv").config();

class App extends Component {
  constructor() {
    super();
    this.state = {
      access_token: "",
      apigee_access_token: "",
      password: "",
      salt: "",
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.getAuthenticate();
  }

  async getAuthenticate() {
    var obj = {
      client_id: "SP_CLIENT_ID",
      client_secret: "SP_CLIENT_SECRET",
      grant_type: "client_credentials",
      resource: "RESOURCE",
      url: "AZURE_TENANT_ID",
    };
    try {
      const response = await axios({
        url: "/authenticate/token",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(
        response.data,
        process.env.REACT_APP_DPR_KVAULT_ENCRYPT
      );
      let decryptedString = bytes.toString(CryptoJS.enc.Utf8);
      let decryptRes = JSON.parse(decryptedString);
      this.setState({ access_token: decryptRes.access_token });
      this.fetchCryptPassword(decryptRes.access_token);
    } catch (e) {
      this.setState({ error: "Failed to authenticate: " + e.message });
    }
  }

  async fetchCryptPassword(accessToken = null) {
    const token = accessToken || this.state.access_token;
    var encrypt_access_token = CryptoJS.AES.encrypt(
      token,
      process.env.REACT_APP_DPR_KVAULT_ENCRYPT
    ).toString();
    var obj = {
      access_token: encrypt_access_token,
      client_id: "REACT_APP_DPR_ENCRYPT_PASSWORD",
      request_var: "cryptPassword",
    };
    try {
      const response = await axios({
        url: "/clientid/keyvault",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(
        response.data,
        process.env.REACT_APP_DPR_KVAULT_ENCRYPT
      );
      let decryptedString = bytes.toString(CryptoJS.enc.Utf8);
      if (!decryptedString) {
        return;
      }
      // Try to parse as JSON first (like Dashboard does)
      try {
        let decryptRes = JSON.parse(decryptedString);
        this.setState({ password: decryptRes });
      } catch (jsonError) {
        // If not JSON, use the string directly
        this.setState({ password: decryptedString });
      }
    } catch (e) {
        console.log(e);
    }
    this.fetchCryptSalt();
  }

  async fetchCryptSalt() {
    var encrypt_access_token = CryptoJS.AES.encrypt(
      this.state.access_token,
      process.env.REACT_APP_DPR_KVAULT_ENCRYPT
    ).toString();
    var obj = {
      access_token: encrypt_access_token,
      client_id: "REACT_APP_DPR_ENCRYPT_SALT",
    };
    try {
      const response = await axios({
        url: "/clientid/keyvault",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(
        response.data,
        process.env.REACT_APP_DPR_KVAULT_ENCRYPT
      );
      let decryptedString = bytes.toString(CryptoJS.enc.Utf8);
      if (!decryptedString) {
        return;
      }
      // Try to parse as JSON first (like Dashboard does)
      try {
        let decryptRes = JSON.parse(decryptedString);
        this.setState({ salt: decryptRes });
      } catch (jsonError) {
        // If not JSON, use the string directly
        this.setState({ salt: decryptedString });
      }
    } catch (e) {
        console.log(e);
    }
    // Continue even if salt fails - password is more critical
    this.setState({ loading: false });
    this.getApigeeClientId();
  }

  async getApigeeClientId() {
    var encrypt_access_token = CryptoJS.AES.encrypt(
      this.state.access_token,
      process.env.REACT_APP_DPR_KVAULT_ENCRYPT
    ).toString();
    var obj = {
      access_token: encrypt_access_token,
      client_id: "REACT_APP_AT_CLIENT_ID",
      request_var: "apigeeClientId",
    };
    try {
      const response = await axios({
        url: "/clientid/keyvault",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(
        response.data,
        process.env.REACT_APP_DPR_KVAULT_ENCRYPT
      );
      let decryptedString = bytes.toString(CryptoJS.enc.Utf8);
      if (decryptedString) {
        let decryptRes = JSON.parse(decryptedString);
        if (decryptRes === "success") {
          this.getApigeeClientSecret();
        }
      } else {
        return;
      }
    } catch (e) {
        console.log(e);
    }
  }

  async getApigeeClientSecret() {
    var encrypt_access_token = CryptoJS.AES.encrypt(
      this.state.access_token,
      process.env.REACT_APP_DPR_KVAULT_ENCRYPT
    ).toString();
    var obj = {
      access_token: encrypt_access_token,
      client_id: "REACT_APP_AT_CLIENT_SECRET",
      request_var: "apigeeClientSecret",
    };
    try {
      const response = await axios({
        url: "/clientid/keyvault",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(
        response.data,
        process.env.REACT_APP_DPR_KVAULT_ENCRYPT
      );
      let decryptedString = bytes.toString(CryptoJS.enc.Utf8);
      if (decryptedString) {
        let decryptRes = JSON.parse(decryptedString);
        if (decryptRes === "success") {
          this.getApigeeAccessToken();
        }
      } else {
        return;
      }
    } catch (e) {
        console.log(e);
    }
  }

  async getApigeeAccessToken() {
    var obj = {
      grant_type: "client_credentials",
      url: "REACT_APP_AT_URL",
      client_id: "REACT_APP_APIGEE",
    };
    try {
      const response = await axios({
        url: "/authenticate/token",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(
        response.data,
        process.env.REACT_APP_DPR_KVAULT_ENCRYPT
      );
      let decryptedString = bytes.toString(CryptoJS.enc.Utf8);
      if (decryptedString) {
        let decryptRes = JSON.parse(decryptedString);
        this.setState({ apigee_access_token: decryptRes });
      } else {
        return;
      }
    } catch (e) {
        console.log(e);
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="app">
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <p>Error loading application. Please refresh the page.</p>
            <p style={{ color: 'red', fontSize: '12px' }}>{this.state.error}</p>
          </div>
        </div>
      );
    }

    return (
      <div className="app">
        <Routes>
            <Route path="/" element={<Navigate to="/email" replace />} />
            <Route
              path="/email"
              element={
                this.state.password ? (
                  <Email password={this.state.password} />
                ) : null
              }
            />
            <Route
              path="/phone"
              element={
                this.state.password ? (
                  <Phone password={this.state.password} />
                ) : null
              }
            />
            <Route
              path="/close_account"
              element={
                this.state.password ? (
                  <DeleteAccount password={this.state.password} />
                ) : null
              }
            />
            <Route
              path="/call-center-email"
              element={
                this.state.password ? (
                  <CallCenterEmail password={this.state.password} />
                ) : null
              }
            />
            <Route
              path="/call-center-phone"
              element={
                this.state.password ? (
                  <CallCenterPhone password={this.state.password} />
                ) : null
              }
            />
            <Route
              path="/email-verify"
              element={
                this.state.salt && this.state.password ? (
                  <EmailVerify
                    access_token={this.state.access_token}
                    password={this.state.password}
                    salt={this.state.salt}
                  />
                ) : (
                  <div className="app">
                    <Header />
                    <SpinnerLoad />
                    <Footer />
                  </div>
                )
              }
            />
            <Route
              path="/otp-verify"
              element={
                this.state.salt ? (
                  <OTPVerify
                    access_token={this.state.access_token}
                    logout={this.logout}
                    password={this.state.password}
                    salt={this.state.salt}
                  />
                ) : null
              }
            />
            <Route
              path="/customer-portal"
              element={
                this.state.password ? (
                  <CustomerPortal password={this.state.password} salt={this.state.salt} />
                ) : null
              }
            />
            <Route
              path="/session-expired"
              element={<SessionExpired />}
            />
            <Route path="/logout" element={<Logout />} />
            <Route
              path="/email-request-confirm"
              element={
                this.state.salt ? (
                  <EmailHR
                    access_token={this.state.access_token}
                    password={this.state.password}
                    salt={this.state.salt}
                  />
                ) : null
              }
            />
          </Routes>
        </div>
      );
  }
}

export default App;
